import React from 'react'
import DefaultLayout from 'js/components/DefaultLayout'
import { Title } from 'react-head'
import Header from 'js/components/Header/Header'
import Button from 'js/components/Button/Button'
import Footer from 'js/components/Footer/Footer'

export default function GetInContact() {
  return (
    <DefaultLayout>
      <Title>California Privacy Rights - Lifesum</Title>
      <Header inverted={false} translated={false} />
      <div className="flex min-h-screen flex-col pt-128">
        <div className="flex grow flex-col items-center justify-center">
          <div className="max-w-768 px-16 md:px-40">
            <h1 className="type-med-plus mb-24">
              Contact Lifesum regarding California Privacy Rights
            </h1>
            <p>
              Use the form below to send us a message. We’ll get back to you as
              soon as we can.
            </p>
            <form
              action="https://submit-form.com/6IctZbtHl8m-zJmVYmDz0"
              target="_self"
              className="mb-24 mt-16"
            >
              <label htmlFor="email" className="mb-4 font-demibold">
                Email address you are using for Lifesum*{' '}
                <span className="type-small block text-grey">
                  Find it under Settings/Account Settings in the app.
                </span>
              </label>
              <input
                className="mb-24 rounded-2 border-1 border-green bg-white px-8 pb-2 pt-6"
                type="email"
                name="email"
                id="email"
                required
              />

              <label htmlFor="message" className="mb-4 font-demibold">
                Your message*
              </label>
              <textarea
                className="mb-24 rounded-2 border-1 border-green bg-white px-8 pb-2 pt-6"
                name="message"
                id="message"
                rows="5"
                required
              ></textarea>
              <Button type="submit">Send</Button>
            </form>
          </div>
        </div>
        <div className="w-full">
          <Footer />
        </div>
      </div>
    </DefaultLayout>
  )
}
